<template>
    <div class="app-preloader">
        <div :class="['lds-grid', { ' lds-grid_red': isMguuRespondent }]">
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
        </div>
    </div>
</template>

<script>
import { defineComponent } from 'vue';
import { mapGetters } from 'vuex';
import AuthRoleCache from '@/cache/auth-role.cache';

export default defineComponent({
    name: 'AppPreloader',

    computed: {
        ...mapGetters(['authUserRoleSlug']),
        isMguuRespondent() {
            const isRespondentRoute =
                /^Respondent|^AssessmentPlansTestsMGUU/.test(
                    this.$route.name ?? '',
                );
            const cachedRole = AuthRoleCache.get();
            const queryRole = this.$route.query?.roleCode;
            return (
                this.app_design_type === 'mguu' &&
                (this.authUserRoleSlug === 'respondent' ||
                    cachedRole === 'respondent' ||
                    isRespondentRoute ||
                    queryRole === 'respondent')
            );
        },
    },
});
</script>

<style scoped lang="scss">
.app-preloader {
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #fff;
}

.lds-grid {
    display: inline-block;
    position: relative;
    width: 80px;
    height: 80px;
}
.lds-grid div {
    position: absolute;
    width: 16px;
    height: 16px;
    border-radius: 50%;
    background: $green;
    animation: lds-grid 1.2s linear infinite;
}

.lds-grid {
    &_red div {
        background: red;
    }
}

.lds-grid div:nth-child(1) {
    top: 8px;
    left: 8px;
    animation-delay: 0s;
}
.lds-grid div:nth-child(2) {
    top: 8px;
    left: 32px;
    animation-delay: -0.4s;
}
.lds-grid div:nth-child(3) {
    top: 8px;
    left: 56px;
    animation-delay: -0.8s;
}
.lds-grid div:nth-child(4) {
    top: 32px;
    left: 8px;
    animation-delay: -0.4s;
}
.lds-grid div:nth-child(5) {
    top: 32px;
    left: 32px;
    animation-delay: -0.8s;
}
.lds-grid div:nth-child(6) {
    top: 32px;
    left: 56px;
    animation-delay: -1.2s;
}
.lds-grid div:nth-child(7) {
    top: 56px;
    left: 8px;
    animation-delay: -0.8s;
}
.lds-grid div:nth-child(8) {
    top: 56px;
    left: 32px;
    animation-delay: -1.2s;
}
.lds-grid div:nth-child(9) {
    top: 56px;
    left: 56px;
    animation-delay: -1.6s;
}
@keyframes lds-grid {
    0%,
    100% {
        opacity: 1;
    }
    50% {
        opacity: 0.5;
    }
}
</style>
